import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Form, Row, Col, FormGroup, FormControl, Button, ButtonToolbar } from 'react-bootstrap'
import { tableHelper, momentHelper } from './helpers'
import ReactPaginate from 'react-paginate'
import './report.css';
import Select from 'react-select'
import FontAwesome from 'react-fontawesome'

class ReportKKCProfit extends Component {

  constructor(props) {
    super(props)

    this.state = {loading:false}
  }

  renderRowData() {
    return(
      <tr>
        <td className='text-center'>1</td>
        <td className='text-center'>960288</td>
        <td className='text-center'>24/07/60</td>
        <td className='text-center'>3/1/61</td>
        <td>ผอ-6657</td>
        <td>กฟอ.ปากช่อง</td>
        <td>เครดิต</td>
        <td>ISUZU NKR</td>
        <td className='text-right'>280,875</td>
        <td className='text-right'>280,875</td>
        <td className='text-right'>20,000</td>
        <td className='text-right'>143,050</td>
        <td className='text-right'>75,921</td>
        <td className='text-center'>41,904</td>
      </tr>
    )
  }
  
  renderTable() {
    return(
      <div className="table-responsive">
        <table className='table table-hover table-bordered-solid'>
          <thead>
            <tr>
              <th colSpan={14} className='text-center'><h2>สรุปรถ ออก รายได้คงเหลือ เดือน มกราคม 2561</h2></th>
            </tr>
            <tr>
              <th rowSpan={2} className='text-center'>ที่</th>
              <th rowSpan={2} className='text-center'>ลำดับ</th>
              <th colSpan={2} className='text-center'>ว/ด/ป</th>
              <th rowSpan={2} className='text-center'>ทะเบียนรถ</th>
              <th rowSpan={2} className='text-center'>เจ้าของผู้รับรถ</th>
              <th className='text-center'>บ.ประกันภัย</th>
              <th className='text-center'>รายการซ่อม</th>
              <th colSpan={6} className='text-center'>เครดิต/เงินสด/ประกันภัย</th>
            </tr>
            <tr>
              <th className='text-center'>รับรถ</th>
              <th className='text-center'>รถออกจริง</th>
              <th className='text-center'>เงินสด</th>
              <th className='text-center'>ชนิดรถ</th>
              <th className='text-center'>ราคาประมูล<br/>และ<br/>เงินสด</th>
              <th className='text-center'>ราคา-ยืนยัน</th>
              <th className='text-center'>ค่าแรงธุรการ<br/>ค่าน้ำ<br/>ค่าไฟ</th>
              <th className='text-center'>ค่าแรงช่าง</th>
              <th className='text-center'>ค่าอะไหล่<br/>+<br/>วัตถุสิ้นเปลือง</th>
              <th className='text-center'>คงเหลือ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
            {this.renderRowData()}
            {this.renderRowData()}
            {this.renderRowData()}
            {this.renderRowData()}
            {this.renderRowData()}
            {this.renderRowData()}
            {this.renderRowData()}
            {this.renderRowData()}
            {this.renderRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    let {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header>          
          
        </Box.Header>
        <Box.Body>
          {this.renderTable()}
        </Box.Body>
      </Box>
    )
  }

}  

ReportKKCProfit.defaultProps = {
  title: ''
}
export default ReportKKCProfit;


// WEBPACK FOOTER //
// ./src/view/report/ReportKKCProfit.js